
export const fieldsConfig = [
  {
    name: "code",
    label: "Currency Code",
    type: "text",
    required: true,
  },
  {
    name: "name",
    label: "Currency Name",
    type: "text",
    required: true,
  },
  {
    name: "symbol",
    label: "Symbol",
    type: "text",
    required: true,
  },
  {
    name: "symbol_position",
    label: "Symbol Position",
    type: "select",
    required: true,
    is_enums_data: true,
    enums: ["before", "after"],
    defaultOptionValue: "before",
  },
  {
    name: "decimal_places",
    label: "Decimal Places",
    type: "number",
    min: 0,
  },
  {
    name: "country_name",
    label: "Country Name",
    type: "text",
  },
  {
    name: "country_code",
    label: "Country Code",
    type: "text",
  },
];
